export default "__VITE_ASSET__CoaLMMtB__"